import React from 'react'
import styles from './school-counters.styles'
import injectSheet from 'react-jss'

const SchoolCounters = ({ classes, views, published, authors }) => (
  <ul className={classes.container}>
    <li className={classes.counter}>
      <strong>{views}</strong>
      <span>views</span>
    </li>
    <li className={classes.counter}>
      <strong>{published}</strong>
      <span>works</span>
    </li>
    <li className={classes.counter}>
      <strong>{authors}</strong>
      <span>authors</span>
    </li>
  </ul>
)

export default injectSheet(styles)(SchoolCounters)
